import {Input, InputProps} from "antd";
import styles from "./VLInput.module.scss";
import classNames from "classnames";
import {forwardRef} from "react";

export const VLInput = forwardRef<{input: HTMLInputElement}, InputProps>(({className,  autoComplete = 'off',...rest}, ref) => {
    const inputClassName = classNames(styles.vlInput, className)
    return (
        <Input ref={ref as any} autoComplete={autoComplete} className={inputClassName} {...rest} />
    )
})